<div class="progress rounded-pill bg-white" role="progressbar" [attr.aria-valuenow]="getExerciseProgressPercent()" aria-valuemin="0" aria-valuemax="100">
    <div class="progress-bar" [style.width]="getExerciseProgressPercent()+'%'"></div>
</div>
